module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/client_6-a376c27b4595c3fa73fa81b3bafaf6bd.png";